var _this = this;
import * as tslib_1 from "tslib";
import { settings } from '../../../settings';
import { AppActionTypes } from './types';
import TranslationResponseMapper from '../../mapper/TranslationResponseMapper';
import { DestinationType, LastMinuteBlockTabType, OptionsParam, ProductQueryParam, ProductType, ResponseStatus, SearchMaskGroupType, Sorting, } from '../../../globalTypes';
import { getAirportSearchResult as getAirportSearchResultService, getSearchResults as getSearchResultService } from '../../../coreStateEngine/store/search/actions';
import ContextCreator from '../../util/ContextCreator';
import Router from '../../util/routing/Router';
import { PackageServiceActionTypes } from '../../../coreStateEngine';
import QueryCreator from '../../util/QueryCreator';
import { getPackageFlightAlternatives as getPackageFlightAlternativesCore, getPackageGroupQueryOptions as getPackageGroupQueryOptionsCore, getPackageGroups as getPackageGroupsCore, getPackageOffers as getPackageOffersCore, getPackageProducts as getPackageProductsCore, getPackageQueryOptions as getPackageQueryOptionsCore, getPackageVariants as getPackageVariantsCore, getPackageSuggestions as getPackageSuggestionsCore, } from '../../../coreStateEngine/store/package/actions';
import { getHotelGroupQueryOptions as getHotelGroupQueryOptionsCore, getHotelGroups as getHotelGroupsCore, getHotelOffers as getHotelOffersCore, getHotelProducts as getHotelProductsCore, getHotelQueryOptions as getHotelQueryOptionsCore, getHotelVariants as getHotelVariantsCore, getHotelSuggestions as getHotelSuggestionsCore, } from '../../../coreStateEngine/store/hotel/actions';
import UserOptionsCreator from '../../util/UserOptionsCreator';
import UserPaginationCreator from '../../util/UserPaginationCreator';
import merge from 'deepmerge';
import { optionParamToAliasMap, optionParamToCoreMap, queryParamToAliasMap, queryParamToCoreMap } from '../../util/routing/MappingConfig/urlMappingConfig';
import { GeoTreeHelper, ProgressBarStep, store } from '../../../index';
import ParamSanitizer from '../../util/routing/ParamSanitizer';
var assetsBaseUrl = settings.webApiHost;
var translationsBasePath = settings.translationsPath;
var airlinesTranslationsBasePath = settings.airlinesTranslationsPath;
var coreBaseUrl = settings.coreApi.host;
export var getTranslations = function (protocol, language, fallbackLanguage) {
    if (fallbackLanguage === void 0) { fallbackLanguage = 'de'; }
    return function (dispatch, getState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var resultGetTranslationsAction, websiteState, currentStep, airlineCodesFromQuery, fallbackTranslationsResponse, airlineTranslations, airlineTranslationsLanguage, airlineTranslationsPromise, airlineTranslationResponse, translationsResponse, translations, fallBackTranslations, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resultGetTranslationsAction = {
                        type: AppActionTypes.RECEIVE_TRANSLATIONS,
                        translations: null
                    };
                    websiteState = getState().websiteState;
                    currentStep = websiteState && websiteState.app && websiteState.app.currentStep ? websiteState.app.currentStep : null;
                    airlineCodesFromQuery = websiteState && websiteState.app && websiteState.app.url && websiteState.app.url.productQuery ? websiteState.app.url.productQuery[ProductQueryParam.FLIGHT_AIRLINE_CODES] : null;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 11, , 12]);
                    fallbackTranslationsResponse = null;
                    if (!(fallbackLanguage !== language)) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetch(protocol + '//' + assetsBaseUrl + translationsBasePath + '/' + fallbackLanguage + '.json')];
                case 2:
                    fallbackTranslationsResponse = _a.sent();
                    _a.label = 3;
                case 3:
                    airlineTranslations = void 0;
                    if (!((ProgressBarStep.INFO_AND_DATES === currentStep && airlineCodesFromQuery && airlineCodesFromQuery.length > 0) || ProgressBarStep.INFO_AND_DATES === currentStep)) return [3 /*break*/, 6];
                    airlineTranslationsLanguage = language.toLowerCase() === 'at' || language.toLowerCase() === 'ch' ? 'de' : language;
                    airlineTranslationsPromise = fetch(protocol + '//' + assetsBaseUrl + airlinesTranslationsBasePath + '/' + airlineTranslationsLanguage + '.json');
                    return [4 /*yield*/, airlineTranslationsPromise];
                case 4:
                    airlineTranslationResponse = _a.sent();
                    return [4 /*yield*/, airlineTranslationResponse.json()];
                case 5:
                    airlineTranslations = (_a.sent());
                    if (airlineTranslationsLanguage !== language) {
                        airlineTranslations.translations[language] = airlineTranslations.translations[airlineTranslationsLanguage];
                        delete airlineTranslations.translations[airlineTranslationsLanguage];
                    }
                    _a.label = 6;
                case 6: return [4 /*yield*/, fetch(protocol + '//' + assetsBaseUrl + translationsBasePath + '/' + language + '.json')];
                case 7:
                    translationsResponse = _a.sent();
                    return [4 /*yield*/, translationsResponse.json()];
                case 8:
                    translations = _a.sent();
                    fallBackTranslations = {};
                    if (!fallbackTranslationsResponse) return [3 /*break*/, 10];
                    return [4 /*yield*/, fallbackTranslationsResponse.json()];
                case 9:
                    fallBackTranslations = (_a.sent());
                    fallBackTranslations.translations[language] = fallBackTranslations.translations[fallbackLanguage];
                    delete fallBackTranslations.translations[fallbackLanguage];
                    _a.label = 10;
                case 10:
                    if (airlineTranslations === null || airlineTranslations === undefined) {
                        resultGetTranslationsAction.translations = merge.all([TranslationResponseMapper.map(fallBackTranslations),
                            TranslationResponseMapper.map(translations)]);
                    }
                    else {
                        resultGetTranslationsAction.translations = merge.all([TranslationResponseMapper.map(airlineTranslations, 'airline_names'),
                            TranslationResponseMapper.map(fallBackTranslations),
                            TranslationResponseMapper.map(translations)]);
                    }
                    return [3 /*break*/, 12];
                case 11:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 12];
                case 12: return [2 /*return*/, dispatch(resultGetTranslationsAction)];
            }
        });
    }); };
};
export var setLocation = function (locationObject) {
    return {
        type: AppActionTypes.SET_LOCATION,
        location: locationObject
    };
};
export var getSearchResults = function (searchString, productType, resultsPerGroupInt, mergeExcludeList, available) {
    return function (dispatch, getState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var lturState, productContext;
        return tslib_1.__generator(this, function (_a) {
            lturState = getState();
            productContext = ContextCreator.create(lturState, mergeExcludeList);
            productContext.productType = productType;
            if (lturState.websiteState && lturState.websiteState.app !== null && lturState.websiteState.app.location !== null) {
                return [2 /*return*/, dispatch(getSearchResultService(lturState.websiteState.app.location.protocol, productContext, searchString, resultsPerGroupInt, available))];
            }
            return [2 /*return*/, dispatch(getSearchResultService('http', productContext, searchString, resultsPerGroupInt, available))];
        });
    }); };
};
export var getAirportSearchResult = function (searchString, mergeExcludeList) {
    return function (dispatch, getState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var lturState, productContext;
        return tslib_1.__generator(this, function (_a) {
            lturState = getState();
            productContext = ContextCreator.create(lturState, mergeExcludeList);
            if (lturState.websiteState && lturState.websiteState.app !== null && lturState.websiteState.app.location !== null) {
                return [2 /*return*/, dispatch(getAirportSearchResultService(lturState.websiteState.app.location.protocol, productContext, searchString))];
            }
            return [2 /*return*/, dispatch(getAirportSearchResultService('http', productContext, searchString))];
        });
    }); };
};
export var setUrlQuery = function (location) {
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var allowedQueryParameters, allowedQueryParameterAliases, allowedQueryParameterArray, allowedOptionParameters, allowedOptionParameterAliases, allowedOptionsParameterArray, pageProductQuery, pageProductOptions, hotelCodeValue, hotelCodeAction, pageQuery;
        return tslib_1.__generator(this, function (_a) {
            allowedQueryParameters = Array.from(queryParamToCoreMap.keys());
            allowedQueryParameterAliases = Array.from(queryParamToAliasMap.keys());
            allowedQueryParameterArray = merge(allowedQueryParameters, allowedQueryParameterAliases);
            allowedOptionParameters = Array.from(optionParamToCoreMap.keys());
            allowedOptionParameterAliases = Array.from(optionParamToAliasMap.keys());
            allowedOptionsParameterArray = merge(allowedOptionParameters, allowedOptionParameterAliases);
            pageProductQuery = {
                type: AppActionTypes.SET_URL_PRODUCT_QUERY,
                productQuery: ParamSanitizer.sanitizeProductQuery(Router.getUrlQueryParamsWithWhitelist(location, allowedQueryParameterArray))
            };
            dispatch(pageProductQuery);
            pageProductOptions = {
                type: AppActionTypes.SET_URL_PRODUCT_OPTIONS,
                productOptions: ParamSanitizer.sanitizeProductOptions(Router.getUrlQueryOptions(location))
            };
            dispatch(pageProductOptions);
            hotelCodeValue = Router.getUrlHotelCode(location);
            if (hotelCodeValue) {
                hotelCodeAction = {
                    type: AppActionTypes.SET_URL_HOTEL_CODE,
                    hotelCode: hotelCodeValue
                };
                dispatch(hotelCodeAction);
            }
            pageQuery = {
                type: AppActionTypes.SET_URL_QUERY,
                query: ParamSanitizer.sanitizeQuery(Router.getUrlQueryParamsWithBlacklist(location, merge(allowedQueryParameterArray, allowedOptionsParameterArray)))
            };
            return [2 /*return*/, dispatch(pageQuery)];
        });
    }); };
};
export var setUrlProductGroupId = function (productGroupId) {
    var hotelProductGroupIdAction = {
        productGroupId: productGroupId,
        type: AppActionTypes.SET_URL_PRODUCT_GROUP_ID,
    };
    store.dispatch(hotelProductGroupIdAction);
};
export var setUrlContext = function (location) {
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var pageContext;
        return tslib_1.__generator(this, function (_a) {
            pageContext = {
                type: AppActionTypes.SET_URL_CONTEXT,
                context: Router.getContextFromUrl(location)
            };
            return [2 /*return*/, dispatch(pageContext)];
        });
    }); };
};
export var setCurrentStep = function (locationObject) {
    return {
        type: AppActionTypes.SET_CURRENT_STEP,
        location: locationObject
    };
};
export var getPackageProducts = function (storageKey, appendResponse, mergeExcludeList, resultsTotal) {
    if (storageKey === void 0) { storageKey = DestinationType.HOTEL_LIST; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState, mergeExcludeList);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState), QueryCreator.createOverrides(lturState));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState));
    if (resultsTotal) {
        options[OptionsParam.PHUB_RESULTS_TOTAL] = resultsTotal;
    }
    options['WITH_SUGGESTION_PROPERTIES'] = true;
    var packageRequest = {
        options: options,
        context: productContext,
        query: productQuery,
        references: ['HOTEL_IMAGES', 'COUPON']
    };
    var pagination = UserPaginationCreator.create(lturState);
    var overridePagination = JSON.parse(JSON.stringify(pagination));
    if (pagination) {
        if (!appendResponse) {
            overridePagination.size = pagination.size + pagination.size * pagination.page;
            overridePagination.page = 0;
        }
        packageRequest.pagination = overridePagination;
    }
    getPackageProductsCore(packageRequest, storageKey, appendResponse);
    if (pagination) {
        packageRequest.pagination = pagination;
    }
    if ('serviceWorker' in navigator
        //@ts-ignore
        && typeof window.lturServiceWorker !== 'undefined'
        //@ts-ignore
        && window.lturServiceWorker.activate) {
        //@ts-ignore
        if (packageRequest.pagination !== 'undefined') {
            setTimeout(function () {
                //@ts-ignore
                packageRequest.pagination.page = packageRequest.pagination.page + 1;
                getPackageProductsCore(packageRequest, storageKey, appendResponse, false);
            }, 1000);
        }
    }
};
export var getPackageGroups = function (storageKey, mergeExcludeList, optionalCoreQuery, optionalOptions) {
    if (storageKey === void 0) { storageKey = DestinationType.DESTINATION; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState, mergeExcludeList);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState), QueryCreator.createOverrides(lturState));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState));
    if (optionalOptions) {
        options = merge(options, optionalOptions);
    }
    var packageRequest = {
        options: options,
        context: productContext,
        query: productQuery,
        references: ['COUPON'],
    };
    var pagination = UserPaginationCreator.create(lturState);
    if (pagination) {
        packageRequest.pagination = pagination;
    }
    if (storageKey === DestinationType.DESTINATION) {
        delete packageRequest.query.PRODUCT_GROUPS;
        packageRequest.query.PRODUCT_GROUPS = [GeoTreeHelper.getTopDestinationsNodeId(ProductType.PACKAGE), GeoTreeHelper.getAllDestinationsNodeId(ProductType.PACKAGE)];
    }
    getPackageGroupsCore(packageRequest, storageKey, optionalCoreQuery);
};
export var getPackageOffers = function (storageKey, departureDate, pagination, resultsTotal, appendResponse, mergeExcludeList, optionalOptions) {
    if (storageKey === void 0) { storageKey = 'default'; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState, mergeExcludeList);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState), QueryCreator.createOverrides(lturState));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState));
    if (resultsTotal) {
        options[OptionsParam.PHUB_RESULTS_TOTAL] = resultsTotal;
    }
    if (optionalOptions) {
        options = merge(options, optionalOptions);
    }
    if (departureDate) {
        productQuery.TRAVEL_PERIOD_DEPARTURE_DATE = departureDate;
        delete productQuery.TRAVEL_PERIOD_RETURN_DATE;
    }
    var customPagination = undefined;
    if (pagination) {
        customPagination = pagination;
    }
    else {
        customPagination = {
            page: 0,
            size: 10,
            sorting: [Sorting.price, Sorting.startDate]
        };
    }
    var packageRequest = {
        options: options,
        context: productContext,
        query: productQuery,
        references: ['BOOKING_HREF', 'COUPON'],
        pagination: customPagination
    };
    getPackageOffersCore(packageRequest, storageKey, appendResponse);
};
export var getPackageVariants = function (storageKey, variantsParam, variantsSize, variantsSorting, variantsFromDate, variantsToDate, mergeExcludeList, optionalOptions) {
    if (storageKey === void 0) { storageKey = 'default'; }
    if (variantsParam === void 0) { variantsParam = ['DEPARTURE_DATE']; }
    if (variantsSize === void 0) { variantsSize = 7; }
    if (variantsSorting === void 0) { variantsSorting = [Sorting.price, Sorting.startDate]; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState, mergeExcludeList);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState), QueryCreator.createOverrides(lturState));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState));
    if (optionalOptions) {
        options = merge(options, optionalOptions);
    }
    if (variantsFromDate && variantsToDate) {
        productQuery.TRAVEL_PERIOD_DEPARTURE_DATE = variantsFromDate;
        productQuery.TRAVEL_PERIOD_RETURN_DATE = variantsToDate;
    }
    var paginationParam = {
        page: 0,
        size: variantsSize,
        sorting: variantsSorting
    };
    var packageRequest = {
        options: options,
        context: productContext,
        query: productQuery,
        variants: variantsParam,
        pagination: paginationParam
    };
    getPackageVariantsCore(packageRequest, storageKey);
};
export var getPackageFlightAlternativesRequest = function (storageKey, departureDate, pagination, resultsTotal, mergeExcludeList, optionalOptions, references) {
    if (storageKey === void 0) { storageKey = 'default'; }
    if (references === void 0) { references = ['BOOKING_HREF', 'BOOKING_ID', 'COUPON', 'HOTEL_ROOMS']; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState, mergeExcludeList);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState), QueryCreator.createOverrides(lturState));
    var options = tslib_1.__assign({ RELAXED_FLIGHT_OFFER_KEY: false, MERGE_SIMILAR_FLIGHTS: false }, UserOptionsCreator.create(lturState));
    if (resultsTotal) {
        options[OptionsParam.PHUB_RESULTS_TOTAL] = resultsTotal;
    }
    if (optionalOptions) {
        options = merge(options, optionalOptions);
    }
    if (departureDate) {
        productQuery.TRAVEL_PERIOD_DEPARTURE_DATE = departureDate;
        delete productQuery.TRAVEL_PERIOD_RETURN_DATE;
    }
    var customPagination = undefined;
    if (pagination) {
        customPagination = pagination;
    }
    else {
        customPagination = UserPaginationCreator.create(lturState);
        customPagination.size = 25;
    }
    var packageRequest = {
        options: options,
        references: references,
        context: productContext,
        query: productQuery,
        pagination: customPagination,
    };
    return packageRequest;
};
export var getPackageFlightAlternatives = function (storageKey, departureDate, pagination, resultsTotal, appendResponse, mergeExcludeList, optionalOptions, updateState) {
    if (storageKey === void 0) { storageKey = 'default'; }
    if (updateState === void 0) { updateState = true; }
    var packageRequest = getPackageFlightAlternativesRequest(storageKey, departureDate, pagination, resultsTotal, mergeExcludeList, optionalOptions);
    getPackageFlightAlternativesCore(packageRequest, storageKey, appendResponse, updateState);
    // TODO: Remove this in the next release (after 0.55.0)
    if ('serviceWorker' in navigator
        //@ts-ignore
        && typeof window.lturServiceWorker !== 'undefined'
        //@ts-ignore
        && window.lturServiceWorker.activate
        && !(packageRequest.options && packageRequest.options.ENABLE_DYNAMIC_PAGING === true)) {
        //@ts-ignore
        if (packageRequest.pagination !== 'undefined') {
            setTimeout(function () {
                //@ts-ignore
                packageRequest.pagination.page = packageRequest.pagination.page + 1;
                getPackageFlightAlternativesCore(packageRequest, storageKey, appendResponse, false);
            }, 1000);
        }
    }
};
export var dispatchEmptyResultsForPackageLastMinuteBlock = function (storageKey) {
    if (storageKey === void 0) { storageKey = LastMinuteBlockTabType.TODAY; }
    var emptyResult = {
        storageKey: storageKey,
        type: PackageServiceActionTypes.RECEIVE_PACKAGE_PRODUCTS_RESPONSE,
        products: {},
        status: ResponseStatus.EMPTY
    };
    store.dispatch(emptyResult);
};
export var getPackageLastMinuteBlockResults = function (departureDate, departureDateMin, duration, storageKey, mergeExcludeList) {
    if (storageKey === void 0) { storageKey = LastMinuteBlockTabType.TODAY; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState, mergeExcludeList);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState, SearchMaskGroupType.LAST_MINUTE), QueryCreator.createOverrides(lturState), { TRAVEL_PERIOD_DEPARTURE_DATE: departureDate, TRAVEL_PERIOD_DURATION: duration });
    delete productQuery.TRAVEL_PERIOD_RETURN_DATE;
    if (departureDateMin) {
        productQuery.TRAVEL_PERIOD_DEPARTURE_TIME_MIN = departureDateMin;
    }
    var packageRequest = {
        context: productContext,
        query: productQuery,
        pagination: {
            page: 1,
            size: 3
        },
        references: ['HOTEL_IMAGES', 'COUPON']
    };
    getPackageProductsCore(packageRequest, storageKey);
};
export var getHotelProducts = function (storageKey, appendResponse, mergeExcludeList, resultsTotal) {
    if (storageKey === void 0) { storageKey = DestinationType.HOTEL_LIST; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState, mergeExcludeList);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState, SearchMaskGroupType.HOTEL), QueryCreator.createOverrides(lturState, SearchMaskGroupType.HOTEL));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState, SearchMaskGroupType.HOTEL));
    if (resultsTotal) {
        options[OptionsParam.PHUB_RESULTS_TOTAL] = resultsTotal;
    }
    options['WITH_SUGGESTION_PROPERTIES'] = true;
    var pagination = UserPaginationCreator.create(lturState, SearchMaskGroupType.HOTEL);
    var request = {
        options: options,
        context: productContext,
        query: productQuery,
        references: ['HOTEL_IMAGES', 'COUPON']
    };
    var overridePagination = JSON.parse(JSON.stringify(pagination));
    if (pagination) {
        if (!appendResponse) {
            overridePagination.size = pagination.size + pagination.size * pagination.page;
            overridePagination.page = 0;
        }
        request.pagination = overridePagination;
    }
    getHotelProductsCore(request, storageKey, appendResponse);
    if (pagination) {
        request.pagination = pagination;
    }
    if ('serviceWorker' in navigator
        //@ts-ignore
        && typeof window.lturServiceWorker !== 'undefined'
        //@ts-ignore
        && window.lturServiceWorker.activate) {
        //@ts-ignore
        if (request.pagination !== 'undefined') {
            setTimeout(function () {
                //@ts-ignore
                request.pagination.page = request.pagination.page + 1;
                getHotelProductsCore(request, storageKey, appendResponse, false);
            }, 1000);
        }
    }
};
export var getHotelGroups = function (storageKey, mergeExcludeList, optionalCoreQuery, optionalOptions) {
    if (storageKey === void 0) { storageKey = DestinationType.DESTINATION; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState, mergeExcludeList);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState, SearchMaskGroupType.HOTEL), QueryCreator.createOverrides(lturState, SearchMaskGroupType.HOTEL));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState, SearchMaskGroupType.HOTEL));
    if (optionalOptions) {
        options = merge(options, optionalOptions);
    }
    var request = {
        options: options,
        context: productContext,
        query: productQuery,
        references: ['COUPON']
    };
    var pagination = UserPaginationCreator.create(lturState, SearchMaskGroupType.HOTEL);
    if (pagination) {
        request.pagination = pagination;
    }
    if (storageKey === DestinationType.DESTINATION) {
        delete request.query.PRODUCT_GROUPS;
        request.query.PRODUCT_GROUPS = [GeoTreeHelper.getAllDestinationsNodeId(ProductType.HOTEL), GeoTreeHelper.getTopDestinationsNodeId(ProductType.HOTEL)];
    }
    getHotelGroupsCore(request, storageKey, optionalCoreQuery);
};
export var getHotelOffers = function (storageKey, departureDate, pagination, resultsTotal, appendResponse, mergeExcludeList, optionalOptions, updateState) {
    if (storageKey === void 0) { storageKey = 'default'; }
    if (updateState === void 0) { updateState = true; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState, mergeExcludeList);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState, SearchMaskGroupType.HOTEL), QueryCreator.createOverrides(lturState, SearchMaskGroupType.HOTEL));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState, SearchMaskGroupType.HOTEL));
    if (resultsTotal) {
        options[OptionsParam.PHUB_RESULTS_TOTAL] = resultsTotal;
    }
    if (optionalOptions) {
        options = merge(options, optionalOptions);
    }
    if (departureDate) {
        productQuery.TRAVEL_PERIOD_DEPARTURE_DATE = departureDate;
        delete productQuery.TRAVEL_PERIOD_RETURN_DATE;
    }
    var customPagination = undefined;
    if (pagination) {
        customPagination = pagination;
    }
    else {
        customPagination = UserPaginationCreator.create(lturState, SearchMaskGroupType.HOTEL);
    }
    var request = {
        options: options,
        context: productContext,
        query: productQuery,
        references: ['BOOKING_HREF', 'BOOKING_ID', 'COUPON', 'HOTEL_ROOMS'],
        pagination: customPagination
    };
    getHotelOffersCore(request, storageKey, appendResponse, updateState);
    // TODO: Remove this in the next release (after 0.55.0)
    if ('serviceWorker' in navigator
        //@ts-ignore
        && typeof window.lturServiceWorker !== 'undefined'
        //@ts-ignore
        && window.lturServiceWorker.activate
        && !(request.options && request.options.ENABLE_DYNAMIC_PAGING === true)) {
        //@ts-ignore
        if (request.pagination !== 'undefined') {
            setTimeout(function () {
                //@ts-ignore
                request.pagination.page = request.pagination.page + 1;
                getHotelOffersCore(request, storageKey, appendResponse, false);
            }, 1000);
        }
    }
};
export var getHotelVariants = function (storageKey, variantsParam, variantsSize, variantsSorting, variantsFromDate, variantsToDate, mergeExcludeList, optionalOptions) {
    if (storageKey === void 0) { storageKey = 'default'; }
    if (variantsParam === void 0) { variantsParam = ['DEPARTURE_DATE']; }
    if (variantsSize === void 0) { variantsSize = 7; }
    if (variantsSorting === void 0) { variantsSorting = [Sorting.price, Sorting.startDate]; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState, mergeExcludeList);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState, SearchMaskGroupType.HOTEL), QueryCreator.createOverrides(lturState, SearchMaskGroupType.HOTEL));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState, SearchMaskGroupType.HOTEL));
    if (optionalOptions) {
        options = merge(options, optionalOptions);
    }
    if (variantsFromDate && variantsToDate) {
        productQuery.TRAVEL_PERIOD_DEPARTURE_DATE = variantsFromDate;
        productQuery.TRAVEL_PERIOD_RETURN_DATE = variantsToDate;
    }
    var paginationParam = {
        page: 0,
        size: variantsSize,
        sorting: variantsSorting
    };
    var request = {
        options: options,
        context: productContext,
        query: productQuery,
        variants: variantsParam,
        pagination: paginationParam
    };
    getHotelVariantsCore(request, storageKey);
};
export var getPackageQueryOptions = function (storageKey) {
    if (storageKey === void 0) { storageKey = 'default'; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState, SearchMaskGroupType.PACKAGE), QueryCreator.createOverrides(lturState, SearchMaskGroupType.PACKAGE));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState, SearchMaskGroupType.PACKAGE));
    var request = {
        options: options,
        context: productContext,
        query: productQuery
    };
    getPackageQueryOptionsCore(request, storageKey);
};
export var getHotelQueryOptions = function (storageKey) {
    if (storageKey === void 0) { storageKey = 'default'; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState, SearchMaskGroupType.HOTEL), QueryCreator.createOverrides(lturState, SearchMaskGroupType.HOTEL));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState, SearchMaskGroupType.HOTEL));
    var request = {
        options: options,
        context: productContext,
        query: productQuery
    };
    getHotelQueryOptionsCore(request, storageKey);
};
export var getPackageGroupQueryOptions = function (storageKey) {
    if (storageKey === void 0) { storageKey = 'default'; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState, SearchMaskGroupType.PACKAGE), QueryCreator.createOverrides(lturState, SearchMaskGroupType.PACKAGE));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState, SearchMaskGroupType.PACKAGE));
    var request = {
        options: options,
        context: productContext,
        query: productQuery
    };
    getPackageGroupQueryOptionsCore(request, storageKey);
};
export var getHotelSuggestions = function (pageSize, storageKey) {
    if (pageSize === void 0) { pageSize = 10; }
    if (storageKey === void 0) { storageKey = 'default'; }
    var lturState = store.getState();
    var context = ContextCreator.create(lturState);
    var query = tslib_1.__assign({}, QueryCreator.create(lturState, SearchMaskGroupType.HOTEL), QueryCreator.createOverrides(lturState, SearchMaskGroupType.HOTEL));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState, SearchMaskGroupType.HOTEL));
    var pagination = {
        page: 0,
        size: pageSize,
        sorting: ['price']
    };
    var suggestionsRequest = {
        options: options,
        context: context,
        query: query,
        pagination: pagination,
        references: ['BOOKING_HREF', 'HOTEL_IMAGES', 'COUPON']
    };
    getHotelSuggestionsCore(suggestionsRequest, storageKey);
};
export var getPackageSuggestions = function (pageSize, storageKey) {
    if (pageSize === void 0) { pageSize = 10; }
    if (storageKey === void 0) { storageKey = 'default'; }
    var lturState = store.getState();
    var context = ContextCreator.create(lturState);
    var query = tslib_1.__assign({}, QueryCreator.create(lturState, SearchMaskGroupType.PACKAGE), QueryCreator.createOverrides(lturState, SearchMaskGroupType.PACKAGE));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState, SearchMaskGroupType.PACKAGE));
    var pagination = {
        page: 0,
        size: pageSize,
        sorting: ['price']
    };
    var suggestionsRequest = {
        options: options,
        context: context,
        query: query,
        pagination: pagination,
        references: ['BOOKING_HREF', 'HOTEL_IMAGES', 'COUPON']
    };
    getPackageSuggestionsCore(suggestionsRequest, storageKey);
};
export var getHotelGroupQueryOptions = function (storageKey) {
    if (storageKey === void 0) { storageKey = 'default'; }
    var lturState = store.getState();
    var productContext = ContextCreator.create(lturState);
    var productQuery = tslib_1.__assign({}, QueryCreator.create(lturState, SearchMaskGroupType.HOTEL), QueryCreator.createOverrides(lturState, SearchMaskGroupType.HOTEL));
    var options = tslib_1.__assign({}, UserOptionsCreator.create(lturState, SearchMaskGroupType.HOTEL));
    var request = {
        options: options,
        context: productContext,
        query: productQuery
    };
    getHotelGroupQueryOptionsCore(request, storageKey);
};
